// removed by extract-text-webpack-plugin
module.exports = {"ScrollToTop":"src-components-ScrollToTop----ScrollToTop-module---ScrollToTop---p3Ksc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ScrollToTop/ScrollToTop.module.css
// module id = 389
// module chunks = 114276838955818